import { GameConstants } from "./../../../GameConstants";
import { RoomManager } from "./../../../managers/RoomManager";
import { GameVars } from "../../../GameVars";

export class ChipsContainer extends Phaser.GameObjects.Container {

    public creditsLabel: Phaser.GameObjects.Text;
    public background: Phaser.GameObjects.Graphics;

    public initialX: number;
    public isPlayer: boolean;
    public rightSide: boolean;

    private id: string;

    constructor(scene: Phaser.Scene, rightSide: boolean, isPlayer: boolean, id: string) {

        super(scene);

        this.id = id;

        if (isPlayer) {
            this.x = 80;
            this.y = -58;
        } else {
            this.x = rightSide ? -80 : 80;
            this.y = 80;
        }

        this.initialX = this.x;
        this.isPlayer = isPlayer;
        this.rightSide = rightSide;
        this.alpha = 0;

        const chip = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "chip.png");
        
        const credits = 0;

        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, 18, -1, GameVars.formatNumber(credits), {fontFamily: "Oswald-Medium", fontSize: "25px", color: "#89e09d"});
        this.creditsLabel.setOrigin(0, .5);
         
        this.background = new Phaser.GameObjects.Graphics(this.scene);
        this.background.fillStyle(0x2e3a3d, .5);
        this.background.fillRoundedRect(-20, -18, 0, 34, 17);
        this.add(this.background);

        this.add(chip);
        this.add(this.creditsLabel);
    }

    public setCredits(bet: number): void {

        this.creditsLabel.text = GameVars.formatNumber(bet);

        this.background.clear();
        this.background.fillStyle(0x2e3a3d, .5);
        this.background.fillRoundedRect(-20, -18, 50 + this.creditsLabel.width, 34, 17);

        if (!this.isPlayer) {
            this.x = this.initialX + 20 - (50 + this.creditsLabel.width) / 2;
        }
    }

    public show(): void {

        if (this. isPlayer) {
            this.x = 80;
            this.y = -58;
        } else {
            this.x = this.rightSide ? -80 : 80;
            this.y = 80;
        }

        this.visible = true;
        this.background.visible = true;
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 150 / GameVars.gameSpeed
        });
    }

    public hide(): void {
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 150 / GameVars.gameSpeed,
            onComplete: () => {
                this.visible = false;
            },
            onCompleteScope: this
        });
    }

    public updateChipsState(): void {

        let player = RoomManager.getPlayer(this.id);

        if (!player) {
            return;
        }

        if (player.chips - player.wagered === 0) {
            this.creditsLabel.setFill("#FF3366");
        } else if (player.state !== GameConstants.ACTIVE) {
            this.creditsLabel.setFill("#BBBBBB");
        } else if (player.wagered < GameVars.gameState.call) {
            this.creditsLabel.setFill("#ECA62F");
        } else if (player.wagered === GameVars.gameState.call) {
            this.creditsLabel.setFill("#89E09D");
        } 
    }
}
